import type { RootState } from '@/rootReducer';
import { shallowEqual, useSelector } from 'react-redux';
import type { ResultReport } from '../@types/types';

export const useReportData = () => {
	const [report, reportIsLoading] = useSelector<
		RootState,
		[ResultReport, boolean]
	>(
		state => [
			state.report.get('getReportsData').toJS(),
			state.report.get('isLoading')
		],
		shallowEqual
	);

	return { report, reportIsLoading };
};
